import { jsx } from "react/jsx-runtime";
import * as React from "react";
const PrismicContext = React.createContext({});
const PrismicProvider = _ref => {
  let {
    client,
    linkResolver,
    richTextComponents,
    internalLinkComponent,
    externalLinkComponent,
    children
  } = _ref;
  const value = React.useMemo(() => ({
    client,
    linkResolver,
    richTextComponents,
    internalLinkComponent,
    externalLinkComponent
  }), [client, linkResolver, richTextComponents, internalLinkComponent, externalLinkComponent]);
  return /* @__PURE__ */jsx(PrismicContext.Provider, {
    value,
    children
  });
};
export { PrismicContext, PrismicProvider };